import React, { useState } from 'react';
import Sidebar from './Sidebar';
import RightSidebar from './RightSidebar';
import { Menu, X } from 'lucide-react';

interface MainLayoutProps {
  children: React.ReactNode;
}

// Import the SidebarProps type from the Sidebar component
interface SidebarProps {
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-vibebops-background flex flex-col md:flex-row relative">
      {/* Mobile Menu Button */}
      <button 
        className="md:hidden fixed top-4 left-4 z-30 p-2 rounded-md bg-vibebops-card border-2 border-black"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        {sidebarOpen ? (
          <X className="h-6 w-6" />
        ) : (
          <Menu className="h-6 w-6" />
        )}
      </button>

      {/* Sidebar - Now accepts open state for mobile */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      
      {/* Main Content */}
      <div className="md:ml-60 flex-1">
        <div className="w-full max-w-[calc(100%-20px)] md:max-w-[calc(100%-40px)] mx-auto py-4 px-2 md:px-4 mt-14 md:mt-0 pb-20 md:pb-4">
          {children}
        </div>
      </div>
      
      {/* Right Sidebar - Already has responsive classes */}
      <RightSidebar />
    </div>
  );
};

export default MainLayout;
